import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  CheckboxContainer,
  CustomCheckbox,
  HiddenCheckbox,
  IconIntermediate,
  IconChecked,
  IconUnchecked,
  IconDisabled
} from './styled';
import { CHECKED, UNCHECKED, INDETERMINATE, DISABLED } from './constants';

const Checkbox = (props) => {
  const { state, checkboxHandler, id } = props;
  const [currentState, setCurrentState] = useState(state);

  useEffect(() => {
    setCurrentState(state);
  }, [state]);

  const handleChange = () => {
    if (state === DISABLED) return;
    if (currentState === UNCHECKED || currentState === INDETERMINATE) {
      setCurrentState(CHECKED);
      checkboxHandler(CHECKED, id);
    } else {
      setCurrentState(UNCHECKED);
      checkboxHandler(UNCHECKED, id);
    }
  };

  const renderCheckbox = () => {
    switch (currentState) {
      case CHECKED:
        return (
          <IconChecked viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </IconChecked>
        );
      case UNCHECKED:
        return (
          <IconUnchecked data-testid="unchecked" viewBox="0 0 24 24">
            <polyline points="0 0" />
          </IconUnchecked>
        );
      case INDETERMINATE:
        return (
          <IconIntermediate viewBox="0 0 24 24">
            <polyline points="4 11 20 11 20 14 4 14 4 11" />
          </IconIntermediate>
        );
      case DISABLED:
        return (
          <IconDisabled viewBox="0 0 24 24">
            <polyline points="0 0" />
          </IconDisabled>
        );
      default:
        return null;
    }
  };
  return (
    <CheckboxContainer onClick={handleChange} data-testid={id}>
      <HiddenCheckbox />
      <CustomCheckbox currentState={currentState}>
        {renderCheckbox()}
      </CustomCheckbox>
    </CheckboxContainer>
  );
};

Checkbox.propTypes = {
  state: PropTypes.string.isRequired,
  checkboxHandler: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Checkbox.defaultProps = {
  state: UNCHECKED,
  checkboxHandler: () => {},
  id: null
};

export default Checkbox;



// WEBPACK FOOTER //
// ./components/checkbox/index.js